import styled, { css } from 'styled-components';
import { FloatActiveSpeakerButton, FloatActiveSpeakerWindow, FullscreenButton } from 'features/Room/components';
import { toggleHideWithTranslateAnimation } from 'ui/mixins';

export const MobileTopbar = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;
`;

export const MobileButtons = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
`;

export const ControlsArea = styled.div<{ $hidden?: boolean }>`
    position: relative;
    z-index: 11;
    grid-area: controls;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: auto;
    padding: 20px 0;
    bottom: 0;
    width: 100%;

    ${({ $hidden }) => toggleHideWithTranslateAnimation($hidden)};

    @media screen and (orientation: landscape) {
        padding: 8px 0 0;
    }
`;

export const SpeakerMobileLayout = styled.section<{ $isWide?: boolean; $isFullscreenActive?: boolean }>`
    height: 100%;
    display: grid;
    grid-template-columns: auto;
    grid-template-rows: auto minmax(0, 1fr) auto auto;
    grid-template-areas:
        'header'
        'main'
        'sidebar'
        'controls';

    // В полноэкранном режиме теряются общие отступы для блока с комнатой, поэтому мы их дублируем здесь.
    ${({ $isFullscreenActive }) =>
        $isFullscreenActive &&
        css`
            padding: var(--mobile-portrait-padding-top) var(--mobile-portrait-padding-right)
                var(--mobile-portrait-padding-bottom) var(--mobile-portrait-padding-left);
        `}

    @media screen and (orientation: landscape) {
        box-sizing: border-box;
        column-gap: ${({ $isWide }) => ($isWide ? '0' : '12px')};
        grid-template-columns: ${({ $isWide }) => ($isWide ? '12fr' : '10fr 2fr')};
        grid-template-rows: auto minmax(0, 1fr) auto;
        grid-template-areas:
            'header sidebar'
            'main sidebar'
            'controls sidebar';

        ${({ $isFullscreenActive }) =>
            $isFullscreenActive &&
            css`
                padding: var(--mobile-landscape-padding);
                overflow-y: hidden;
            `}
    }
`;

export const HeaderLayout = styled.header<{ $hidden?: boolean }>`
    grid-area: header;
    display: block;
    ${({ $hidden }) => toggleHideWithTranslateAnimation($hidden, 'translateY(-100%)')};
`;

export const MainLayout = styled.main`
    grid-area: main;
    margin-bottom: 8px;
    position: relative;
    width: 100%;

    @media screen and (orientation: landscape) {
        margin-bottom: 0;
    }
`;

export const SidebarLayout = styled.aside<{ $hidden?: boolean }>`
    display: ${({ $hidden }) => ($hidden ? 'none' : 'block')};
    grid-area: sidebar;
    overflow: hidden;
    width: 100%;
`;

export const MobileFullscreenButton = styled(FullscreenButton)`
    bottom: 4px;
    right: 4px;

    ${({ isFullscreenActive }) =>
        isFullscreenActive &&
        css`
            @media screen and (orientation: landscape) {
                bottom: 10px;
                right: 4px;
            }
        `}
`;

export const MobileExitFullscreenButton = styled(MobileFullscreenButton)`
    display: flex;
`;

export const MobileFloatActiveSpeakerButton = styled(FloatActiveSpeakerButton)`
    position: absolute;
    top: 4px;
    right: 4px;
    z-index: 2;
`;

export const MobileFloatActiveSpeakerWindow = styled(FloatActiveSpeakerWindow)`
    position: absolute;
    top: 4px;
    right: 4px;
    width: 132px;
    z-index: 2;
`;
